module.exports = __webpack_public_path__ + "static/media/tpn-ce-1.e15e7552.jpg";